(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tb-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tb-carousel')) {
    class TbCarousel extends HTMLElement {
      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('[data-slide]'));
        this.dots = Array.from(this.querySelectorAll('[data-dot]'));
        this.toggle = this.querySelector('[data-toggle]');
        this.index = 0;
        this.speed = parseInt(this.dataset.speed, 10) || 5000;
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.paused = this.dataset.autoplay !== 'true' || reduce || this.slides.length < 2;
        this.querySelector('[data-prev]')?.addEventListener('click', () => this.go(this.index - 1, true));
        this.querySelector('[data-next]')?.addEventListener('click', () => this.go(this.index + 1, true));
        this.dots.forEach((dot) => dot.addEventListener('click', () => this.go(Number(dot.dataset.dot), true)));
        this.toggle?.addEventListener('click', () => this.setPaused(!this.paused));
        document.addEventListener('shopify:block:select', (event) => {
          const i = this.slides.indexOf(event.target);
          if (i > -1) { this.go(i, true); }
        });
        this.setPaused(this.paused);
      }
      disconnectedCallback() {
        clearInterval(this.timer);
      }
      go(i, manual) {
        const n = this.slides.length;
        this.index = (i + n) % n;
        this.slides.forEach((slide, k) => {
          const on = k === this.index;
          slide.classList.toggle('is-active', on);
          slide.toggleAttribute('inert', !on);
          if (on) { slide.removeAttribute('aria-hidden'); } else { slide.setAttribute('aria-hidden', 'true'); }
        });
        this.dots.forEach((dot, k) => {
          if (k === this.index) { dot.setAttribute('aria-current', 'true'); } else { dot.removeAttribute('aria-current'); }
        });
        if (manual) { this.setPaused(true); }
      }
      setPaused(paused) {
        this.paused = paused;
        clearInterval(this.timer);
        this.classList.toggle('is-paused', paused);
        if (this.toggle) {
          this.toggle.setAttribute('aria-label', paused ? this.toggle.dataset.labelPlay : this.toggle.dataset.labelPause);
        }
        if (!paused) {
          this.timer = setInterval(() => this.go(this.index + 1, false), this.speed);
        }
      }
    }
    customElements.define('tb-carousel', TbCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tb-newsletter-popup"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tb-newsletter-popup')) {
    class TbNewsletterPopup extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('dialog');
        if (!this.dialog) return;
        this.key = 'tbNewsletterPopup';
        this.querySelectorAll('[data-close]').forEach((el) => el.addEventListener('click', () => this.close()));
        this.dialog.addEventListener('cancel', () => this.remember('dismissed'));
        this.dialog.addEventListener('click', (event) => {
          if (event.target === this.dialog) this.close();
        });
        if (this.querySelector('[data-subscribed]') || this.querySelector('[data-error]')) {
          if (this.querySelector('[data-subscribed]')) this.remember('subscribed');
          this.open();
          return;
        }
        if (this.hasAttribute('data-preview')) {
          this.open();
          return;
        }
        if (this.recentlySeen()) return;
        const delay = parseInt(this.dataset.delay, 10) || 8000;
        this.timer = setTimeout(() => this.open(), delay);
      }
      disconnectedCallback() {
        clearTimeout(this.timer);
      }
      recentlySeen() {
        try {
          const raw = localStorage.getItem(this.key);
          if (!raw) return false;
          const data = JSON.parse(raw);
          if (data.state === 'subscribed') return true;
          const days = parseInt(this.dataset.days, 10) || 14;
          return Date.now() - data.at < days * 86400000;
        } catch (e) {
          return false;
        }
      }
      remember(state) {
        try {
          localStorage.setItem(this.key, JSON.stringify({ state, at: Date.now() }));
        } catch (e) {}
      }
      open() {
        if (this.dialog.open || document.querySelector('dialog[open]:not(.tb-popup)')) return;
        this.lastFocus = document.activeElement;
        this.dialog.showModal();
        const input = this.dialog.querySelector('input[type="email"]');
        if (input && !input.value) input.focus();
      }
      close() {
        if (!this.querySelector('[data-subscribed]')) this.remember('dismissed');
        this.dialog.close();
        if (this.lastFocus && this.lastFocus.focus) this.lastFocus.focus();
      }
    }
    customElements.define('tb-newsletter-popup', TbNewsletterPopup);
  }

  } catch(e) { console.error(e); }
})();
})();
